<template>
<div>
  <section :class="'cart-sidebar-modal recommend-product-modal cart-wrapper ' + (active ? ' active' : '')">

    <div :class="'cart-sidebar-modal-content p0'">

      <h2 class="order-summary-heading added-recommend-heading border-bottom-none is-size-4 has-text-centered">
        <a href="#" @click.prevent="closeCartModal()" class="close"><img src="@/assets/img/close_24px.png"/></a> <span class="has-text-weight-semibold has-text-dark">Added to Cart</span>
      </h2>
    
      <!-- <slide-y-down-transition group> -->
        <cart-recommend-added-item :item="item" v-for="(item, index) in addedProducts" v-bind:key="'cart-added-prodict-item' + index"/>
      <!-- </slide-y-down-transition> -->

      <div class="recommend-products-wrapper bg-lightgrey">
        <div class="recommend-products-container">
          <h3 class="is-size-4 has-text-weight-semibold has-text-dark mb20">Frequently Bought Together</h3>
          <cart-recommend-product-item :callback="goToLocationProductDetail" :item="item" v-bind:key="'recommend_'+ item.id" v-for="item in recommendProducts" />
        </div>
      </div>

   
    </div>


    <!-- Cart action -->
    <div class="sidebar-cart-checkout-actions cart-recommend-products">

      <div class="recommend-product-cart-overview">
        <div class="is-flex justify-content-between align-items-center">
          <p class="has-text-dark is-size-16px has-text-weight-semibold">Cart Total ({{ vg_cartEveryItemCount }} {{ vg_cartEveryItemCount > 1 ? 'items': 'item'}}): </p>
          <p class="has-text-dark is-size-22px has-text-weight-semibold" v-if="!vg_is_greenline_pos">${{ vg_cartSubTotal }}</p>
        </div>
      </div>

      <div class="recommend-action-mobile">
        <button @click.prevent="closeCartModal()" class="button mb15 mt-5 is-primary-outline is-medium is-full-width">
        CONTINUE SHOPPING
        </button>
        <a
          @click.prevent="showCartModal()"
          href="#"
          class="button is-full-width text-white mb15 justify-content-center bg-secondary btn-complete is-medium has-text-semibold-18"
        >
          REVIEW CART
        </a>
      </div>

    </div>
    <!-- Cart action ends -->
  </section>
 
</div>
</template>

<script>
import CartRecommendAddedItem from '@/Components/Pages/PageComponents/Cart/CartRecommendAddedItem';
import CartRecommendProductItem from '@/Components/Pages/PageComponents/Cart/CartRecommendProductItem';
import { SlideYDownTransition } from 'vue2-transitions';
import CartApis from '@/Components/Controllers/CartApis';
import ProductApis from '@/Components/Controllers/ProductApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';

export default {
  components: {
    CartRecommendAddedItem,
    CartRecommendProductItem,
    SlideYDownTransition
  },

  name: 'CartRecommendProducts',
  data() {
    return {
      active: false, 
      addedProducts: [],
      recommendProducts: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      vg_cartId: "cart/id",
      vg_cartEveryItemCount: "cart/cartEveryItemCount",
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_is_greenline_pos: "location/is_greenline_pos",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_userId: "getLoggedInUserId",
    }),
  },

  watch: {
   
  },

  async mounted() {
    const self = this;
    // Handle on open close modal background body scroll
    bus.$on('added-to-cart-recommend-products', async (payload) => {
      if(payload.modal){
        self.addedProducts = [];
        self.recommendProducts = [];
        this.active = true;
        document.body.classList.add('product-recommend-modal-active');
        self.addedProducts.push(payload.addedProduct);
        self.recommendProducts = payload.recommendProducts;
      } else {
        document.body.classList.remove('product-recommend-modal-active');
        self.recommendProducts = [];
      }
    })
    // when item is addred to card from recommend product item pass it to added item
    bus.$on('added-to-cart-recommend-product-added', async (payload) => {
      self.addedProducts.push(payload);
    })
    // when item is addred to card from recommend product item pass it to added item
    bus.$on('added-to-cart-recommend-product-removed', async (product) => {
     let checkExistingProduct = _.find(self.addedProducts, { location_product_id: parseInt(product.location_product_id), location_product_variant_id: parseInt(product.location_product_variant_id) });
      if(checkExistingProduct && checkExistingProduct != undefined) {
          await this.removeItem(checkExistingProduct);
      }
      
      if(self.addedProducts.length == 0) {
        self.addedProducts = [];
        self.recommendProducts = [];
        this.active = false;
      }

    })
  },
  
  beforeDestroy() {
    bus.$off('added-to-cart-recommend-products');
  },

  methods: {
    /**
     * Move backwards
     */
    closeCartModal() {
      this.active = false;
      document.body.classList.remove('cart-modal-active');
      this.addedProducts = [];
      this.recommendProducts = [];
    },

    /**
     * Move to checkout
     */
    async showCartModal() {
      this.closeCartModal();
      bus.$emit('open-sidebar-cart', true)
    },


    /**
     * Move to locaiton product detail page
     */
    goToLocationProductDetail(item) {
      // We do not set them the selected value because huge load of data need to save and carried as they already are on recommend
      // SO refetch data
      this.va_setStoreProfileRecord({
        data: [],
      })
      this.closeCartModal();
      let queryToremove =  ['category', 'verify_email', 'token'];
      if(this.vg_userId){
        queryToremove.push('referral_key')
      }
      this.$router.push({ 
        name: 'LocationProductDetail', 
        params: { 
          business_slug: this.$route.params.business_slug,
          store_slug: this.$route.params.store_slug, 
          product_id: item.id 
        },
        query: Helpers.refineQuery(queryToremove, this.$route.query)
      })
    },

    /**
     * refine unnecessary query
     */
    // refineQuery(query) {
    //   let removeObj = ['category', 'verify_email', 'token'];
    //   removeObj.forEach( (item) => {
    //     if(query.hasOwnProperty(item)){
    //       delete query[item];
    //     } 
    //   })
    //   return query;
    // },

     async removeItem(item) {
      const self = this;
      // here we are working with product data from frontend but for dlete we need cart product id from cart response
     let product =  _.find(this.vg_cartItems, { location_product_id: item.location_product_id, location_product_variant_id: item.location_product_variant_id });
      if(product == undefined) {
        return;
      }
      // Hit an api to remove cart items
      let res = await CartApis.delete({
        cart_product_id: product.id,
        location_id: this.$store.getters['location/selected'].id ? this.$store.getters['location/selected'].id : '',
      });
     
      if(res.status == 200){
        // activate variant
        let targetItem = document.getElementById('recomment_variants'+ product.location_product_variant_id);
        if(targetItem) {
          targetItem.classList.remove("added")
        }
        // Now remove for list 
        let filteredData = self.addedProducts.filter(item => {
           if(item.location_product_id == product.location_product_id && item.location_product_variant_id == product.location_product_variant_id){
            // do nothing
           } else {
            return item;
           }
        })
  
        // let filteredData = _.filter(self.addedProducts, function(currentObject) {
        //   return (currentObject.location_product_id != product.location_product_id && currentObject.location_product_variant_id != product.location_product_variant_id);
        // });
        // console.log(filteredData)
        self.addedProducts = filteredData;
  
        if(this.$store.getters.getLoggedInUserToken){
          // remove from vbout , for logged in user
          VboutApis.removeCartItem({
            cartid: this.$store.getters['cart/id'],
            productid: product.id,
            variation: { 
              variation_id: product.selected_variant.id, 
            },
          }, this.vg_selectedStore.id);
        }
        
        // G tracking remove cart item
        this.$gtag.event('remove_from_cart', { 
          items: [
            {
              id: product.location_product_id,
              name: product.product_name, 
              brand: product.brand_name ? product.brand_name : null,
              category: product.category_name ? product.category_name : null,
              variant: product.selected_variant.size ? product.selected_variant.size : null,
              quantity: parseInt(product.unit),
              price: product.price,
            }
          ]
        });
      }
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.status == 200 ? 'success' : 'error',
      });
     
    },
   
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
      va_setStoreProfileRecord: "storeprofile/setStoreProfileRecord",
    })

  },
};
</script>
<style scoped>

.added-product-overview{
  padding: 20px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
}
.bg-lightgrey{
  background-color: #F9F9F9;
}
.order-summary-heading.added-recommend-heading{
  padding-bottom: 15px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 15px;
  margin-bottom: 0px;
}
.recommend-product-cart-overview {
    padding: 20px 20px;
    margin-left: -20px;
    margin-right: -20px;
    /* margin-bottom: 15px; */
}
.sidebar-cart-checkout-actions.cart-recommend-products {
  padding-top: 0;
  height: 210px;
  border-top: 1px solid #ccc;
}
.recommend-product-modal .cart-sidebar-modal-content{
  height: calc(100vh - 210px);
}
@media only screen and (max-width: 768px) {
  .sidebar-cart-checkout-actions.cart-recommend-products {
    height: 150px;
  }
  .recommend-product-modal .cart-sidebar-modal-content {
    height: calc(100vh - 150px);
  }
  .recommend-action-mobile {
      display: flex;
      justify-content: space-between;
  }
  .recommend-action-mobile a, 
  .recommend-action-mobile button {
      height: 40px;
      display: flex;
      width: 47% !important;
      padding: 0 !important;
      text-align: right;
      justify-content: center;
      margin-top: 0;
      align-items: center;
  }
}
</style>
